import React from "react";
import FieldValue from "./FieldValue";
import styles from "../../styles/results.module.css";
import Field from "./Field";
import PhotosContainer from "./PhotosContainer";
import PersonalInformation from "./PersonalInformation";
import { PrimaryDocument } from "../../types/api/application.type";
import { IPrimaryDocumentImages } from "../../types/onboard";
import { useTranslation } from "react-i18next";

interface DocumentDetailsProps {
  primaryDocument: PrimaryDocument;
  primaryDocumentImages: IPrimaryDocumentImages
}

const DocumentDetails: React.FC<DocumentDetailsProps> = ({
  primaryDocument,
  primaryDocumentImages
}) => {
  const InfoField = ({ label, value }: { label: string; value: string }) => (
    <div className={styles.infoField}>
      <Field text={label} />
      <FieldValue text={value} />
    </div>
  );
  const {t} = useTranslation();
  return (
    <div className={styles.infoDocContainer}>
      <div className={styles.infoBody}>
        <div className={styles.infoFields}>
          <PersonalInformation
            portrait={primaryDocument?.documentPortrait?.imageData as string}
            givenName={primaryDocument?.idAttributes?.firstName}
            surname={primaryDocument?.idAttributes?.lastName}
            issuingCountry={primaryDocument?.docAttributes?.issuingCountry}
          />
          {primaryDocument?.documentNumber && (
            <InfoField
              label={t('review.personaldetail.documentid')}
              value={primaryDocument?.documentNumber}
            />
          )}

          {primaryDocument?.idAttributes?.dateOfBirth && (
            <InfoField
              label={t('review.personaldetail.dob')}
              value={primaryDocument?.idAttributes?.dateOfBirth}
            />
          )}
          {primaryDocument?.docAttributes?.issueDate && (
            <InfoField
              label={t('review.personaldetail.documentissue')}
              value={primaryDocument?.docAttributes?.issueDate}
            />
          )}
          {primaryDocument?.docAttributes?.expiryDate && (
            <InfoField
              label={t('review.personaldetail.documentexpiry')}
              value={primaryDocument?.docAttributes?.expiryDate}
            />
          )}
        </div>
      </div>
      <PhotosContainer
        documentFront={primaryDocument?.frontImage?.imageData }
        documentBack={primaryDocument?.backImage?.imageData}
        primaryDocumentImages={primaryDocumentImages}
      />
    </div>
  );
};

export default DocumentDetails;
